import {animate, style, transition, trigger} from '@angular/animations';

export const opacityTranslateYTrigger = trigger('opacityTranslateY', [
  transition(':enter', [
    style({opacity: 0, transform: 'translateY(-0.25rem)'}),
    animate(
      '200ms ease-out',
      style({opacity: 1, transform: 'translateY(0)'}),
    ),
  ]),
  transition(':leave', [
    style({opacity: 1, transform: 'translateY(0)'}),
    animate(
      '150ms ease-in',
      style({opacity: 0, transform: 'translateY(-0.25rem)'}),
    ),
  ]),
]);
